import {
  PAYMENTS_CLAIMS_PAID_REQUEST,
  PAYMENTS_CLAIMS_PAID_SUCCESS,
  PAYMENTS_CLAIMS_PAID_FAILURE,
  PAYMENTS_CLAIMS_PAID_LOADING,
  PAYMENTS_CLAIMS_SUMMARY_REQUEST,
  PAYMENTS_CLAIMS_SUMMARY_SUCCESS,
  PAYMENTS_CLAIMS_SUMMARY_FAILURE,
  PAYMENTS_CLAIMS_SUMMARY_LOADING,
  CLAIMS_YIELD_ALL_PASSES_METRICS_REQUEST,
  CLAIMS_YIELD_ALL_PASSES_METRICS_SUCCESS,
  CLAIMS_YIELD_ALL_PASSES_METRICS_FAILURE,
  CLAIMS_YIELD_ALL_PASSES_METRICS_LOADING,
  SERVICE_TYPE_PASS_WISE_METRICS_REQUEST,
  SERVICE_TYPE_PASS_WISE_METRICS_SUCCESS,
  SERVICE_TYPE_PASS_WISE_METRICS_FAILURE,
  SERVICE_TYPE_PASS_WISE_METRICS_LOADING,
  PAYMENTS_CLAIMS_DOP_REQUEST,
  PAYMENTS_CLAIMS_DOP_SUCCESS,
  PAYMENTS_CLAIMS_DOP_FAILURE,
  PAYMENTS_CLAIMS_DOP_LOADING,
  CLAIMS_BIFURCATE_METRICS_REQUEST,
  CLAIMS_BIFURCATE_METRICS_SUCCESS,
  CLAIMS_BIFURCATE_METRICS_FAILURE,
  CLAIMS_BIFURCATE_METRICS_LOADING,
  PAYMENTS_POLLING_STARTED,
  PAYMENTS_POLLING_COMPLETED,
  PAYMENTS_POLLING_FAILED,
  PAYMENTS_POLLING_RESET,
  PAYMENTS_CLAIMS_DOP_CANCEL,
  PAYMENTS_CLAIMSBIFURCATE_CANCEL,
  PAYMENTS_CLAIMSPAID_CANCEL,
  PAYMENTS_CLAIMSSUMMARY_CANCEL,
  PAYMENTS_CLAIMSYIELD_CANCEL,
  PAYMENTS_CLAIMS_SERVICE_PASS_CANCEL
} from '../actionTypes';

export const fetchPaymentsClaimsPaidRequest = (payload: any) => ({
  type: PAYMENTS_CLAIMS_PAID_REQUEST,
  payload,
});

export const fetchPaymentsClaimsPaidSuccess = (payload: any) => ({
  type: PAYMENTS_CLAIMS_PAID_SUCCESS,
  payload,
});

export const fetchPaymentsClaimsPaidError = (payload: any) => ({
  type: PAYMENTS_CLAIMS_PAID_FAILURE,
  payload,
});

export const fetchPaymentsClaimsPaidLoading = (payload: any) => ({
  type: PAYMENTS_CLAIMS_PAID_LOADING,
  payload,
});

export const fetchPaymentsClaimsDopRequest = (payload: any) => ({
  type: PAYMENTS_CLAIMS_DOP_REQUEST,
  payload,
});

export const fetchPaymentsClaimsDopSuccess = (payload: any) => ({
  type: PAYMENTS_CLAIMS_DOP_SUCCESS,
  payload,
});

export const fetchPaymentsClaimsDopError = (payload: any) => ({
  type: PAYMENTS_CLAIMS_DOP_FAILURE,
  payload,
});

export const fetchPaymentsClaimsDopLoading = (payload: any) => ({
  type: PAYMENTS_CLAIMS_DOP_LOADING,
  payload,
});

export const fetchClaimsBifurcateMericsRequest = (payload: any) => ({
  type: CLAIMS_BIFURCATE_METRICS_REQUEST,
  payload,
});

export const fetchClaimsBifurcateMericsSuccess = (payload: any) => ({
  type: CLAIMS_BIFURCATE_METRICS_SUCCESS,
  payload,
});

export const fetchClaimsBifurcateMericsError = (payload: any) => ({
  type: CLAIMS_BIFURCATE_METRICS_FAILURE,
  payload,
});

export const fetchClaimsBifurcateMericsLoading = (payload: any) => ({
  type: CLAIMS_BIFURCATE_METRICS_LOADING,
  payload,
});

export const fetchPaymentsClaimsSummaryRequest = (payload: any) => ({
  type: PAYMENTS_CLAIMS_SUMMARY_REQUEST,
  payload,
});

export const fetchPaymentsClaimsSummarySuccess = (payload: any) => ({
  type: PAYMENTS_CLAIMS_SUMMARY_SUCCESS,
  payload,
});

export const fetchPaymentsClaimsSummaryError = (payload: any) => ({
  type: PAYMENTS_CLAIMS_SUMMARY_FAILURE,
  payload,
});

export const fetchPaymentsClaimsSummaryLoading = (payload: any) => ({
  type: PAYMENTS_CLAIMS_SUMMARY_LOADING,
  payload,
});

export const fetchClaimsYieldAllPassesMetricsRequest = (payload: any) => ({
  type: CLAIMS_YIELD_ALL_PASSES_METRICS_REQUEST,
  payload,
});

export const fetchClaimsYieldAllPassesMetricsSuccess = (payload: any) => ({
  type: CLAIMS_YIELD_ALL_PASSES_METRICS_SUCCESS,
  payload,
});

export const fetchClaimsYieldAllPassesMetricsError = (payload: any) => ({
  type: CLAIMS_YIELD_ALL_PASSES_METRICS_FAILURE,
  payload,
});

export const fetchClaimsYieldAllPassesMetricsLoading = (payload: any) => ({
  type: CLAIMS_YIELD_ALL_PASSES_METRICS_LOADING,
  payload,
});

export const fetchServiceTypePassWiseMetricsRequest = (payload: any) => ({
  type: SERVICE_TYPE_PASS_WISE_METRICS_REQUEST,
  payload,
});

export const fetchServiceTypePassWiseMetricsSuccess = (payload: any) => ({
  type: SERVICE_TYPE_PASS_WISE_METRICS_SUCCESS,
  payload,
});

export const fetchServiceTypePassWiseMetricsError = (payload: any) => ({
  type: SERVICE_TYPE_PASS_WISE_METRICS_FAILURE,
  payload,
});

export const fetchServiceTypePassWiseMetricsLoading = (payload: any) => ({
  type: SERVICE_TYPE_PASS_WISE_METRICS_LOADING,
  payload,
});

export const paymentsPollingStarted = () => ({
  type: PAYMENTS_POLLING_STARTED,
});

export const paymentsPollingCompleted = () => ({
  type: PAYMENTS_POLLING_COMPLETED,
});

export const paymentsPollingFailed = (error: any) => ({
  type: PAYMENTS_POLLING_FAILED,
  payload: error,
});

export const paymentsPollingReset = () => ({
  type: PAYMENTS_POLLING_RESET,
});

export const getPaymentsClaimsDOPCancel = () => ({
  type: PAYMENTS_CLAIMS_DOP_CANCEL,
});
export const getPaymentsClaimsBifurcateCancel = () => ({
  type: PAYMENTS_CLAIMSBIFURCATE_CANCEL,
});
export const getPaymentsClaimsPaidCancel = () => ({
  type: PAYMENTS_CLAIMSPAID_CANCEL,
});
export const getPaymentsClaimsSummaryCancel = () => ({
  type: PAYMENTS_CLAIMSSUMMARY_CANCEL,
});
export const getPaymentsClaimsYieldCancel = () => ({
  type: PAYMENTS_CLAIMSYIELD_CANCEL,
});
export const getPaymentsClaimsServiceCancel = () => ({
  type: PAYMENTS_CLAIMS_SERVICE_PASS_CANCEL,
});
